var _defs, _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 190 118",
    width: 190,
    height: 118,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "roundedClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 190,
    height: 119,
    rx: 5,
    ry: 5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    href: "#P",
    gradientTransform: "matrix(-70.523,.008,-0.001,-50.104,140.952,114.142)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8fafc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8fafc",
    stopOpacity: 1
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n  .a{fill:none;stroke:#d0d5dd}.b{fill:url(#g1)}.c{fill:#d9d9d9}.d{fill:#ed6a5e}.e{fill:#f5bd4f}.f{fill:#61c454}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#roundedClip)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m0 0h192v118h-192z",
    fill: "url(#g1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m60.5 13.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m66.5 9h8c0.8 0 1.5 0.7 1.5 1.5v1c0 0.8-0.7 1.5-1.5 1.5h-8c-0.8 0-1.5-0.7-1.5-1.5v-1c0-0.8 0.7-1.5 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m79.4 9h3.6c0.8 0 1.5 0.7 1.5 1.5v1c0 0.8-0.7 1.5-1.5 1.5h-3.6c-0.8 0-1.5-0.7-1.5-1.5v-1c0-0.8 0.7-1.5 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m87.6 9h3.6c0.8 0 1.5 0.7 1.5 1.5v1c0 0.8-0.7 1.5-1.5 1.5h-3.6c-0.8 0-1.5-0.7-1.5-1.5v-1c0-0.8 0.7-1.5 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m95.8 9h3.5c0.9 0 1.5 0.7 1.5 1.5v1c0 0.8-0.6 1.5-1.5 1.5h-3.5c-0.8 0-1.5-0.7-1.5-1.5v-1c0-0.8 0.7-1.5 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m104 9h3.5c0.9 0 1.5 0.7 1.5 1.5v1c0 0.8-0.6 1.5-1.5 1.5h-3.5c-0.8 0-1.5-0.7-1.5-1.5v-1c0-0.8 0.7-1.5 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m122.5 9h7c0.8 0 1.5 0.7 1.5 1.5v1c0 0.8-0.7 1.5-1.5 1.5h-7c-0.8 0-1.5-0.7-1.5-1.5v-1c0-0.8 0.7-1.5 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m117.5 9h1c0.8 0 1.5 0.7 1.5 1.5v1c0 0.8-0.7 1.5-1.5 1.5h-1c-0.8 0-1.5-0.7-1.5-1.5v-1c0-0.8 0.7-1.5 1.5-1.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m6.9 8.6c-0.9 0-1.7-0.7-1.7-1.7 0-0.9 0.8-1.6 1.7-1.6 0.9 0 1.6 0.7 1.6 1.6 0 1-0.7 1.7-1.6 1.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m11.8 8.6c-0.9 0-1.6-0.7-1.6-1.7 0-0.9 0.7-1.6 1.6-1.6 0.9 0 1.6 0.7 1.6 1.6 0 1-0.7 1.7-1.6 1.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m16.7 8.6c-0.9 0-1.6-0.7-1.6-1.7 0-0.9 0.7-1.6 1.6-1.6 0.9 0 1.7 0.7 1.7 1.6 0 1-0.8 1.7-1.7 1.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m19.5 36.6h33c0.8 0 1.5 0.7 1.5 1.5v1c0 0.8-0.7 1.5-1.5 1.5h-33c-0.8 0-1.5-0.7-1.5-1.5v-1c0-0.8 0.7-1.5 1.5-1.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m19.5 43h57c0.8 0 1.5 0.7 1.5 1.5v1c0 0.8-0.7 1.5-1.5 1.5h-57c-0.8 0-1.5-0.7-1.5-1.5v-1c0-0.8 0.7-1.5 1.5-1.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m19.6 49h57c0.8 0 1.5 0.7 1.5 1.5v1c0 0.8-0.7 1.5-1.5 1.5h-57c-0.8 0-1.5-0.7-1.5-1.5v-1c0-0.8 0.7-1.5 1.5-1.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m19.6 55h57c0.8 0 1.5 0.7 1.5 1.5v1c0 0.8-0.7 1.5-1.5 1.5h-57c-0.8 0-1.5-0.7-1.5-1.5v-1c0-0.8 0.7-1.5 1.5-1.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m19.5 61h37c0.8 0 1.5 0.7 1.5 1.5v1c0 0.8-0.7 1.5-1.5 1.5h-37c-0.8 0-1.5-0.7-1.5-1.5v-1c0-0.8 0.7-1.5 1.5-1.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m20.5 68.4c1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m26.5 68.4c1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m32.5 68.4c1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m38.5 68.4c1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m15 105.5c0-0.8 0.7-1.5 1.5-1.5h47c0.8 0 1.5 0.7 1.5 1.5v12.5h-50z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m70 105.5c0-0.8 0.7-1.5 1.5-1.5h47c0.8 0 1.5 0.7 1.5 1.5v12.5h-50z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m125 105.5c0-0.8 0.7-1.5 1.5-1.5h47c0.8 0 1.5 0.7 1.5 1.5v12.5h-50z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRegular);
export default __webpack_public_path__ + "static/media/white-regular.1be75a286f6303bab5997227fac9f9da.svg";
export { ForwardRef as ReactComponent };